<template>
    <div class="ix-operations-form">
        <div class="mb-4">
            <div class="ix-comments-loader" v-if="loadingTimelines">
                <i class="far fa-circle-notch fa-spin"></i> Chargement des chronologies prédéfinies
            </div>

            <div v-if="timelines.length > 0">
                <div class="input-group">
                    <select class="form-control" v-model="selectedTimeline">
                        <option :value="null">Choisissez une chronologie prédéfinie à importer</option>
                        <option :value="timeline" v-for="(timeline, index) in timelines" v-bind:key="index">{{ timeline.name }}</option>
                    </select>
                    <div class="input-group-append">
                        <button :disabled="selectedTimeline == null" class="ix-btn blue" @click="importTimeline(selectedTimeline)" type="button">Importer</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="ix-comments-loader" v-if="loading || loadingStations">
            <i class="far fa-circle-notch fa-spin"></i> Chargement des opérations
        </div>

        <div v-if="!loading && !loadingStations">
            <draggable v-model="operations" tag="div" handle=".handle-line" >
                <div v-for="(operation, index) in operations" is="operation-form"
                    v-bind:key="operation.uniq"
                    :requiredStation="requiredStation"
                    :operation="operation"
                    :index="index"
                    :formsRoute="formsRoute"
                    :states="states"
                    :controlStates="controlStates"
                    :stations="stations"
                    v-on:operation-state-changed="updateStates($event)"
                    v-on:operation-deleted="deleteRow($event)"
                ></div>
            </draggable>

            <button @click="addRow()" type="button" class="ix-btn ix-btn-small blue ix-btn-block">
                <i class="far fa-plus"></i> Ajouter une opération
            </button>

            <div class="ix-operations-end">
                <i class="far fa-flag-checkered"></i> Fin processus
            </div>
        </div>
    </div>
</template>

<script>
    import OperationForm from "./OperationForm";
    import draggable from 'vuedraggable';
    import Swal from "sweetalert2";

    export default {
        name: 'operation-table-form',
        props: ['formsRoute', 'timelinesRoute', 'stationsRoute', 'oldOperations', 'operationStates', 'operationControlStates', 'stationRequired'],
        components : {
            OperationForm,
            draggable
        },
        data() {
            return {
                loading: true,
                loadingTimelines: true,
                loadingStations: true,
                operations: [],
                timelines: [],
                stations: [],
                selectedTimeline: null,
                states: JSON.parse(this.operationStates),
                controlStates: JSON.parse(this.operationControlStates),
                requiredStation: this.stationRequired ? this.stationRequired : 0
            };
        },
        computed: {
        },
        methods : {
            importTimeline: function(timeline) {
                Swal.fire({
                    title: 'Attention !',
                    text:`L'ensemble des opérations actuellement renseignées seront perdues`,
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Annuler',
                    confirmButtonText: 'Importer',
                    reverseButtons: true,
                    heightAuto: false
                }).then((result) => {
                    if (result.isConfirmed == true) {
                        this.importTimelineOperations(timeline)
                    }
                })
            },
            importTimelineOperations: function(timeline) {
                this.operations = []
                timeline.operations.forEach((operation, index) => {
                    operation.id = null
                    this.addRow(operation)
                })
                this.selectedTimeline = null
            },
            addRow: function (operation) {
                var data = {
                    id: null,
                    uniq: Math.random().toString(36).substr(2, 9),
                    designation: '',
                    description: null,
                    is_control_required: 0,
                    form_id: null,
                    form_designation: '',
                    state: 1,
                    control_state: 1,
                    station_id: null
                }

                if (operation != null) {
                    data.id = operation.id
                    data.designation = operation.designation
                    data.description = operation.description
                    data.is_control_required = operation.is_control_required
                    data.form_id = operation.form_id
                    data.form_designation = operation.form_designation
                    data.state = operation.state
                    data.control_state = operation.control_state
                    data.station_id = operation.station_id
                }

                this.operations.push(data)
            },
            updateStates: function (index) {
                var operationNewState = this.operations[index].state
                var operationIndex = index

                this.operations.forEach((operation, index) => {
                    if (operationNewState == 3 && index < operationIndex) {
                        operation.state = 3
                    }

                    if (operationNewState != 3) {
                        if (index > operationIndex) {
                            operation.state = 1
                        } else if(index < operationIndex && operationNewState == 2) {
                            operation.state = 3
                        }
                        
                    }
                })
            },
            deleteRow: function (index) {
                this.operations.splice(index, 1)
                if (this.operations.length == 0) {
                    this.addRow()
                }
            },
            getSteps: async function (route) {
                this.loading = true;
                fetch(route, {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    return response.json();
                }).then((data) => {
                    data.forEach(operation => {
                        this.addRow(operation)
                    })
                    this.loading = false
                }).catch(error => {
                    console.log(error)
                });
            },
            getTimelines: async function () {
                this.loadingTimelines = true;
                fetch(this.timelinesRoute, {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    return response.json();
                }).then((data) => {
                    this.timelines = data
                    this.loadingTimelines = false
                    this.fillOperations()
                }).catch(error => {
                    this.loadingTimelines = false
                    this.fillOperations()
                    console.log(error)
                });
            },
            getStations: async function () {
                this.loadingStations = true;
                fetch(this.stationsRoute, {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    return response.json();
                }).then((data) => {
                    this.stations = data
                    this.loadingStations = false
                }).catch(error => {
                    this.loadingStations = false
                    console.log(error)
                });
            },
            fillOperations: function() {
                const jsonOperationBackup = JSON.parse(this.oldOperations)
                if (Array.isArray(jsonOperationBackup)) {
                    if (jsonOperationBackup.length == 0) {
                        var timelineIndex = this.timelines.findIndex(timeline => {
                            return timeline.is_default == 1
                        })

                        if (timelineIndex >= 0) {
                            this.importTimelineOperations(this.timelines[timelineIndex])
                        } else {
                            this.addRow(null)
                        }
                    } else {
                        jsonOperationBackup.forEach(operation => {
                            this.addRow(operation)
                        })
                    }
                    this.loading = false
                } else {
                    this.getSteps(jsonOperationBackup)
                }
            }
        },
        async mounted(){
            await this.getStations()
            await this.getTimelines()
        }
    }
</script>
